import styled from 'styled-components';

const SchedulePageHolder = styled.div`
	grid-area: content;
	overflow: auto;
	width: 100%;
    margin: 0 auto;
	.row {
        clear: both;
        display: flex;
        justify-content: space-around;
        flex-flow: row;
        align-items: stretch;
	}
	.schedule-timezone-filter {
		display: flex;
		justify-content: center;
		border-bottom: 1px solid #d1cdc1;
	    max-width: 960px;
    	margin: 40px auto;
    	text-align: center;

		@media all and (device-width: 768px) and (device-height: 1024px) and (orientation:portrait) {
			margin: 40px 15px 0px 15px;
		}

		@media only screen and (max-width: 767px) {
			display: block;
		}
		p {
			font-weight: 500;
			font-size: 17px;
			color: #383838;
			line-height: 1.5em;
			display: inline-block;
			font-family:"Open Sans", sans-serif;
			@media only screen and (max-width: 767px) {
				font-size: 14px;
			}
    	}
		button {
			text-transform: uppercase;
			color: #7a7652;
			cursor: pointer;
			font-size: 12px;
			font-weight: 700;
			border: unset;
			height: 28px;
			text-align: left;
			border-radius: 50%;
			outline: 0;
			background-color: transparent;
		}
		button:hover {
			background-color: #a69e87; 
			color: #fdfdfc;
		}
		ul {
			margin-left: .4rem;
			@media only screen and (max-width: 767px) {
				margin-left: -2.6rem;
			}
		}
		li {
			margin-left: .6rem;
			max-width: 25px;
			padding-left:10px;
		}
	}
	#js-timezone-picker {
		display: flex;
		list-style-type:none;
		padding: 0;
		justify-content: center;
		@media only screen and (max-width: 767px) {
			margin-bottom: 0px;
			margin-top: 0px;
		}
	   .selected {
			background-color: #383429;
			color: #fdfdfc;
		}
	}
	.schedule-list-wrapper .date-label--mobile {
        display: none;
		@media only screen and (max-width: 767px) {
			display: block;
			font-size: 16px;
			color: #383838;
			text-transform: uppercase;
			font-weight: bold;
			padding: 5px;		
		}
    }
	.accordion {
		max-width: 960px;
		margin-left: auto;
		margin-right: auto;
		line-height: 3;
		border-bottom: 1px solid #d1cdc1;
		display: flex;
		justify-content: center;

		@media only screen and (max-device-width: 1024px) and (min-device-width: 768px) and (orientation: portrait) {
			margin-left: 20px;
			margin-right: 20px;
		}

		@media only screen and (max-width: 767px) {
			padding-right: 10px;
			.schedule-date {
				display: none;
			}
		}
		&.accordion--showContent {
			.accordion-content-description {
				display: block;
				font-family: "Open Sans", sans-serif;
				line-height: 1.5em;
				font-size: 17px;
				font-weight: 500;
				p { 
					@media only screen and (min-width: 768px) {
						padding-left: 50px;
					}
				}
				div {
					margin-bottom: 1em;
				}
				img {
					max-width: 100%;	
					transform: scale(0.8);
					@media only screen and (min-width: 768px) {
						padding-left: 100px;
					}
				}
			}
		}
		&.accordion--hideContent {
			.accordion-content-description {
				display: none;
			}  
		}	
		.schedule-show-details {
			flex: 1 0 59.33%;
			text-align:left;
		}
		.schedule-title {
			display: inline-flex;
			margin-top: 15px;
			margin-left: 50px;
			color: rgb(122, 118, 82);
			text-transform: uppercase;
			font-size: 18px;
			line-height: 25px;
			cursor: pointer;
			pointer-events: fill;
			font-family: "Quicksand", sans-serif;
			@media only screen and (max-width: 767px) {
				margin-left: 0px;
				line-height: 1.2;
			}
		}
	    .schedule-show-time {
			flex: 1 0 16.66%;
			display: flex;
			align-items: flex-start;
			@media only screen and (max-width: 767px) {
				padding-left: 20px;
				margin-right: 20px;
				flex: none;
			}
		    .schedule-time {
				margin-left: auto;
				font-size: 18px;
				color: #383838;
				text-transform: uppercase;
				font-family: "Quicksand", sans-serif;
				flex-basis: 60px;
				text-align: center;
				@media only screen and (max-width: 767px) {
					margin-left: 0px;
				}
			}
			.schedule-date {
				font-size: 18px;
				color: #383838;
				text-transform: uppercase;
				font-weight: bold;
				font-family: "Quicksand", sans-serif;
			}
		}	
		&.accordion--showContent .cpac-icon-chevron svg {
			margin-top: 20px;
			transform: rotate(180deg);
			color: #a69e87;
		}
		&.accordion--hideContent .cpac-icon-chevron svg {
			margin-top: 20px;
			color: #a69e87;
		}
		.sched-details div {
			@media only screen and (min-width: 768px) {
				padding-left: 50px;
			}
		}
    } 
`;

export default SchedulePageHolder;